
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { ConfigurationApiClient } from "../clients/ConfigurationApiClient";
import { IIndicatorStatus } from "./models/IIndicatorStatus";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class IndicatorStatusService
{
	private readonly url: string;

	constructor(private readonly apiClient: ConfigurationApiClient)
    {
        this.url = "indicatorstatus";
    }

    async getAll(): Promise<IIndicatorStatus[]>
    {
        return await this.apiClient.get<IIndicatorStatus[]>(`${this.url}/`);
    }

    async getById(id: number): Promise<IIndicatorStatus>
    {
        return await this.apiClient.get<IIndicatorStatus>(`${this.url}/${id}`);
    }
}
